import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import labelAndInput from '../common/form/labelAndInput'

import If from '../common/operador/if'
import { init } from './carneAction'



class CarneForm extends Component {


    render() {
        const { handleSubmit, readOnly } = this.props
        const formatData = (value) => {
            let dateTime = value.split(' ')
            let dtSplit = dateTime[0].split('-')
            return `${dtSplit[2]}/${dtSplit[1]}/${dtSplit[0]} ${dateTime[1]}`
        }

        const currencyFormatter = (value) => {
            if (value === undefined) value = 0
            var valor = value;

            valor = valor + '';
            valor = parseInt(valor.replace(/[\D]+/g, ''));
            valor = valor + '';
            valor = valor.replace(/([0-9]{2})$/g, ",$1");

            if (valor.length > 6) {
                valor = valor.replace(/([0-9]{3}).([0-9]{2}$)/g, ".$1,$2");
            }

            return valor
        }

        return (
            <div>

                <form role='form' onSubmit={handleSubmit}>

                    <div className="box-body">


                        <Field name='id' component={labelAndInput}
                            label='Id'
                            cols='12 2'
                            placeholder='Id'
                            readOnly={true} />

                        <Field name='dt_cadastro' component={labelAndInput}
                            type='text' cols='12 2'
                            label='Data Cadastro' placeholder='Informe a Agência'
                            readOnly={true}
                            format={formatData} />

                        <Field name='valor' component={labelAndInput}
                            label='Valor das Parcelas'
                            cols='12 2'
                            type='numeric'
                            readOnly={readOnly}
                            format={currencyFormatter} />

                        <Field name='nome_cliente' component={labelAndInput}
                            cols='12 6'
                            label='Nome Cliente'
                            readOnly={readOnly} />

                        {/* final da primeira linha */}

                        <Field name='cpf_cnpj_cliente' component={labelAndInput}
                            label='CPF'
                            cols='12 2'
                            readOnly={readOnly} />

                        <Field name='endereco' component={labelAndInput}
                            type='text' cols='12 4'
                            label='Endereço'
                            readOnly={readOnly} />

                        <Field name='municipio' component={labelAndInput}
                            type='text' cols='12 3'
                            label='Município'
                            readOnly={readOnly} />

                        <Field name='cep' component={labelAndInput}
                            type='text' cols='12 2'
                            label='CEP'
                            readOnly={readOnly} />

                        <Field name='uf' component={labelAndInput}
                            type='text' cols='12 1'
                            label='Uf'
                            readOnly={readOnly}
                        />
                       
                        {/* final da segunda linha */}

                        {/* Inicio Terceira Linha */}
                        <Field name='usuario_cadsatro.nome' component={labelAndInput}
                            type='text' cols='12 3'
                            label='Usuário de Cadastro'
                            readOnly={true} />

                        <Field name='usuario_cancelamento.nome' component={labelAndInput}
                            type='text' cols='12 3'
                            label='Usuário Cancelamento'
                            readOnly={true} />

                        {/* Final Terceira Linha */}

                    </div>
                    <div className="boxfooter">
                        <If test={this.props.isFormDelete}>
                            <button type='submit'
                                className={`btn btn-${this.props.submitClass}`}>
                                <i className={`fa fa-${this.props.iconSubmit}`}></i>
                                <span className='space-icon'>{this.props.submitLabel}</span>
                            </button>
                        </If>
                        <button type='button' className="btn btn-default"
                            onClick={this.props.init} ><i className="fa fa-ban"></i><span className='space-icon'>Cancelar</span></button>
                    </div>
                </form>
            </div>
        )
    }
}

CarneForm = reduxForm({ form: 'carneForm', destroyOnUnmount: false })(CarneForm)
const selector = formValueSelector('carneForm')
const mapStateToProps = state => ({

})
const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(CarneForm)



// WEBPACK FOOTER //
// ./src/carne/carneForm.jsx